import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { TopMenu } from '../pageElements/TopMenu';
import { PageHeader } from '../pageElements/PageHeader';
import { ColorContextProvider } from '../pageElements/ColorContext';
import { Breadcrumbs } from '../pageElements/Breadcrumbs';
import { useUserContext } from '../UserContext';
import { TitleAndGroups } from '../pageElements/AnalyticsStages/TitleAndGroups';
import { muniname } from '../../utils';
import * as API from '../API';
import './AnalyticsEditPage.scss';
const createEmptyAnalysis = (title = '', knr) => {
    return {
        title,
        description: '',
        addedGroups: knr ? { single: [{ key: knr, aggregation: 'Enkeltkommuner' }] } : {},
        groupCat: 'single',
    };
};
const createEmptyCtaGroups = () => {
    return {
        'single': [],
        'county': [],
        'kostra': [],
        'custom': []
    };
};
export const AnalyticsEditPage = ({ pageData }) => {
    var _a, _b, _c, _d, _e;
    const userContext = useUserContext();
    const infoRef = useRef(null);
    const [analysis, setAnalysis] = useState(createEmptyAnalysis());
    const { data: municipalityInfoData } = useQuery(`kb/kommuner/${pageData === null || pageData === void 0 ? void 0 : pageData.knr}`, () => { var _a; return API.fetchMunicipalityInfo((_a = pageData === null || pageData === void 0 ? void 0 : pageData.knr) !== null && _a !== void 0 ? _a : ''); }, { enabled: !!(pageData === null || pageData === void 0 ? void 0 : pageData.knr) });
    const analysisId = Number.parseInt((_a = (window.location.hash.split('/').pop())) !== null && _a !== void 0 ? _a : '');
    const analyses = (_d = (_c = (_b = userContext === null || userContext === void 0 ? void 0 : userContext.data) === null || _b === void 0 ? void 0 : _b.userData) === null || _c === void 0 ? void 0 : _c.analyticsRoom) === null || _d === void 0 ? void 0 : _d.analyses;
    //const analysesKey = analyses?.map( ( item ) => `${ item.id }:${ item.title }:${ item.description }` ).join( '|' ) ?? '';
    useEffect(() => {
        if (municipalityInfoData && analysis === null) {
            setAnalysis({
                title: 'Ny analyse',
                addedGroups: { single: [
                        {
                            key: municipalityInfoData.kommune_knr,
                            title: municipalityInfoData.kommune_navn,
                            text: `${municipalityInfoData.kommune_knr} ${municipalityInfoData.kommune_navn} kommune`,
                            value: municipalityInfoData.kommune_knr,
                            members: [municipalityInfoData.kommune_knr]
                        }
                    ]
                }
            });
        }
    }, [municipalityInfoData]);
    useEffect(() => {
        if (analysisId) {
            API.userspaceFetchAnalysis(analysisId)
                .then((a) => {
                if (!a.error) {
                    setAnalysis(a);
                }
            });
        }
    }, [analysisId]);
    if (municipalityInfoData) {
        infoRef.current = municipalityInfoData;
    }
    let kicker = null;
    if ((pageData === null || pageData === void 0 ? void 0 : pageData.knr) && infoRef.current) {
        kicker =
            _jsx(PageHeader.Kicker, { href: `#kommuner/${pageData === null || pageData === void 0 ? void 0 : pageData.knr}`, title: `Gå til forsiden for ${(_e = infoRef.current) === null || _e === void 0 ? void 0 : _e.kommune_navn}`, children: muniname(infoRef.current) });
    }
    // Delay 1 second, to filter out high-frequency updates from GUI events
    const delayTimer = useRef(null);
    let updatedAnalysis = null;
    const updateAnalysis = (field) => {
        if (delayTimer.current !== null) {
            clearTimeout(delayTimer.current);
            delayTimer.current = null;
        }
        setAnalysis((currentAnalysis) => {
            updatedAnalysis = Object.assign(Object.assign({}, (currentAnalysis !== null && currentAnalysis !== void 0 ? currentAnalysis : createEmptyAnalysis('', pageData === null || pageData === void 0 ? void 0 : pageData.knr))), { [field.type]: field.value });
            return updatedAnalysis;
        });
        delayTimer.current = setTimeout(() => {
            var _a;
            delayTimer.current = null;
            if (!updatedAnalysis)
                return;
            const analysisId = parseInt((_a = window.location.hash.split('/').pop()) !== null && _a !== void 0 ? _a : '0');
            if (analysisId > 0) {
                API.userspacePutAnalysis(updatedAnalysis, analysisId);
            }
            else {
                API.userspacePostAnalysis(updatedAnalysis)
                    .then((r) => {
                    if (!r.error) {
                        window.location.hash = window.location.hash.replace('ny', String(r.analysisId));
                    }
                });
            }
            if (field.type === "customGroups") {
                API.userspacePutCustomGroups(field.value);
            }
        }, 1000);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("header", { className: "analytics-room", children: [_jsx(TopMenu, { sticky: true, simple: true, urlTemplate: "#analyserommet/analyse/ny/{kommune_knr}" }), _jsx("div", { className: "topline page-dim", children: _jsx(Breadcrumbs, { light: true }) })] }), _jsx("main", { className: "analytics-room analytics-edit-page", children: _jsx(ColorContextProvider, { children: _jsx(TitleAndGroups, { step: 1, analysis: analysis, knr: pageData === null || pageData === void 0 ? void 0 : pageData.knr, updateAnalysis: updateAnalysis }) }) })] }));
};
